import api from "./authService";

// import api from './api';
// api
const verificationService = {
  // Submit vendor verification
  async submitVendorVerification(verificationData) {
    try {
      const response = await api.post('/vendor/verification/submit', verificationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get verification status - returns array of user_verifications records
  async getVerificationStatus() {
    try {
      const response = await api.get('/vendor/verification/status');
      return response.data.verifications || [];
    } catch (error) {
      // If no verifications exist, return empty array
      if (error.response?.status === 404) {
        return [];
      }
      throw error;
    }
  },

  // Upload verification document to S3 (uploaded immediately when file is selected)
  async uploadDocument(file, documentType, onUploadProgress) {
    try {
      const formData = new FormData();
      formData.append('document', file);
      formData.append('document_type', documentType);

      const response = await api.post('/vendor/verification/upload-document', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (onUploadProgress) {
            onUploadProgress(percentCompleted);
          }
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update vendor profile
  async updateVendorProfile(profileData) {
    try {
      const response = await api.post('/vendor/verification/update-profile', profileData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get vendor profile
  async getVendorProfile() {
    try {
      const response = await api.get('/vendor/profile');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get verification history
  async getVerificationHistory() {
    try {
      const response = await api.get('/vendor/verification/history');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get current verification status with detailed info
  async getCurrentVerificationStatus() {
    try {
      const response = await api.get('/vendor/verification/current');
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null; // No verification exists
      }
      throw error;
    }
  },

  // Resubmit verification (if rejected)
  async resubmitVerification(verificationData) {
    try {
      const response = await api.post('/vendor/verification/resubmit', verificationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Submit verification and update profile in a single transaction
  async submitVerificationWithProfile(data) {
    try {
      const response = await api.post('/vendor/verification/submit-with-profile', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default verificationService;
